import type { UseTimeAgoMessages, UseTimeAgoUnit, UseTimeAgoUnitNamesDefault } from '@vueuse/core'

const pluralise = (n: number, plural: string = 'er') => n > 1 ? plural : ''

const UNIT_BREAKPOINTS: UseTimeAgoUnit<UseTimeAgoUnitNamesDefault>[] = [
  { max: 60000, value: 1000, name: 'second' },
  { max: 2760000, value: 60000, name: 'minute' },
  { max: 72000000, value: 3600000, name: 'hour' },
  { max: 518400000, value: 86400000, name: 'day' },
  { max: 2419200000, value: 604800000, name: 'week' },
  { max: 28512000000, value: 2592000000, name: 'month' },
  { max: Number.POSITIVE_INFINITY, value: 31536000000, name: 'year' },
]

const DANISH_MESSAGES: UseTimeAgoMessages<UseTimeAgoUnitNamesDefault> = {
  justNow: 'lige nu!',
  past: n => n.match(/\d/) ? `${n} siden` : n,
  future: n => n.match(/\d/) ? `om ${n}` : n,
  month: (n, past) => n === 1
    ? past
      ? 'sidste måned'
      : 'næste måned'
    : `${n} måned${pluralise(n)}`,
  year: (n, past) => n === 1
    ? past
      ? 'sidste år'
      : 'næste år'
    : `${n} år}`,
  day: (n, past) => n === 1
    ? past
      ? 'igår'
      : 'imorgen'
    : `${n} dag${pluralise(n, 'e')}`,
  week: (n, past) => n === 1
    ? past
      ? 'sidste uge'
      : 'næste uge'
    : `${n} uge${pluralise(n), 'r'}`,
  hour: n => `${n} time${pluralise(n, 'r')}`,
  minute: n => `${n} minut${pluralise(n, 'ter')}`,
  second: n => `${n} sekund${pluralise(n)}`,
  invalid: 'hva\' faen, der er nå\'et galt??',
}

export const useTimeAgoDk = (date: Ref<Date>, updateInterval: number = 1000) => {
  return useTimeAgo(date, {
    messages: DANISH_MESSAGES,
    units: UNIT_BREAKPOINTS,
    updateInterval,
  })
}
